module.exports = __webpack_public_path__ + "img/sb.2a884be7.png";